import { css } from "styled-components";
/** @mixin ie11Mixin */

/**
 * Only render the given styles in IE11.
 *
 * @example
 * import { ie11Mixin } from '@zillow/constellation';
 *
 * const ie11Styles = css`
 *     color: red;
 * `;
 *
 * const Component = styled.div`
 *     color: blue;
 *     ${ie11Mixin(ie11Styles)}
 * `;
 *
 * <Component>The text is red in IE11, blue otherwise</Component>
 *
 * @method
 * @param {CSSObject} styles - A styled-compoennts css object.
 * @return {CSSObject}
 */

export var ie11Mixin = function ie11Mixin(styles) {
  return function () {
    return css(["_:-ms-fullscreen &,&{", "}"], styles);
  };
};